import { render, staticRenderFns } from "./PenaltyPopup.vue?vue&type=template&id=f19fcbc4"
import script from "./PenaltyPopup.vue?vue&type=script&lang=js"
export * from "./PenaltyPopup.vue?vue&type=script&lang=js"
import style0 from "./PenaltyPopup.vue?vue&type=style&index=0&id=f19fcbc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports